<template>
  <div class="layout-content app-wrap-p">
    <v-card tile outlined class="layout-content__toolbar">
      <slot name="toolbar"></slot>
    </v-card>
    <div class="layout-content-main">
      <div class="layout-content-main__inner" :style="[computeWidth()]">
        <slot name="main"></slot>
      </div>
      <v-card
        outlined
        tile
        v-if="$slots.aside"
        class="layout-content-main__aside"
      >
        <slot name="aside"></slot>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutContent',
  methods: {
    computeWidth() {
      return {
        width:
          this.$slots.aside && this.$vuetify.breakpoint.width > 824
            ? 'calc(100% - 412px)'
            : '100%'
      };
    }
  }
};
</script>

<style lang="sass">
.layout-content
  &__toolbar
    border-left: none !important
    border-right: none !important

.layout-content__toolbar .v-toolbar__content
  padding-right: 10px !important

.custom-table .v-data-footer
  margin-right: 0 !important

.layout-content-main
  display: flex
  height: calc(100% - 66px)

  &__inner
    width: 100%
    transition: all ease .3s

  &__aside
    border: 0 !important
    width: 412px
    flex-shrink: 0
    height: calc(100vh - 130px)
    transition: all ease-in-out 0.3s
    @media (max-width: 824px)
      display: none
      width: 0
    &:after
      content: ""
      display: block
      position: absolute
      background: rgba(0, 0, 0, 0.12)
      width: 1px
      height: calc(100% - 8px)
      top: 8px
    &:empty
      width: 0

.theme--dark .layout-content-main__aside:after
  background: rgba(255, 255, 255, 0.12)
</style>
